import { Controller } from "stimulus"

// Bugfix 32 (#1566): de rusttimer die altijd onderaan staat, zoals in het
// ontwerp ("Rusttijd 2:00  Start"). Handmatig te starten; de tijd is de
// rusttijd van de oefening waar de sporter het laatst op tikte (of de eerste
// oefening). Het automatisch starten na een afgevinkte set blijft zoals het was
// (ticket 751): de server zet dan een lopende timer over deze balk heen.
export default class extends Controller {
  static values = { seconden: Number }
  static targets = ["tijd", "knoptekst", "voortgang", "balk"]

  connect() {
    this.totaal = this.standaard()
    this.over = this.totaal
    this.toon()
  }

  disconnect() {
    this.stop()
  }

  standaard() {
    return this.secondenValue > 0 ? this.secondenValue : 90
  }

  // Een oefeningkaart is aangetikt: zijn rusttijd wordt de tijd van de balk,
  // zolang de timer niet loopt.
  kies(event) {
    const seconden = parseInt(event.detail?.seconden ?? event.params?.seconden, 10)
    if (this.timer || !(seconden > 0)) return
    this.secondenValue = seconden
    this.totaal = seconden
    this.over = seconden
    this.toon()
  }

  wissel() {
    if (this.timer) {
      this.stop()
      this.over = this.totaal
      this.toon()
    } else {
      this.start()
    }
  }

  start() {
    this.totaal = this.standaard()
    this.over = this.totaal
    if (this.hasBalkTarget) this.balkTarget.classList.add("ca-rust-loopt")
    this.toon()
    this.timer = setInterval(() => {
      this.over -= 1
      if (this.over <= 0) {
        this.klaar()
      } else {
        this.toon()
      }
    }, 1000)
  }

  klaar() {
    this.stop()
    if (navigator.vibrate) navigator.vibrate([200, 100, 200])
    this.over = this.totaal
    this.toon()
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    if (this.hasBalkTarget) this.balkTarget.classList.remove("ca-rust-loopt")
  }

  toon() {
    if (this.hasTijdTarget) {
      const m = Math.floor(this.over / 60)
      const s = this.over % 60
      this.tijdTarget.textContent = `${m}:${String(s).padStart(2, "0")}`
    }
    if (this.hasKnoptekstTarget) {
      this.knoptekstTarget.textContent = this.timer ? this.knoptekstTarget.dataset.stop : this.knoptekstTarget.dataset.start
    }
    if (this.hasVoortgangTarget) {
      const pct = this.timer ? Math.max(0, Math.min(100, (this.over / this.totaal) * 100)) : 0
      this.voortgangTarget.style.width = `${pct}%`
    }
  }
}
